import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { PaisComponent } from './pages/pais/pais.component';
import { ProductComponent } from './pages/product/product.component';
import { LogUserComponent } from './pages/adminUser/logUser/logUser.component';
import { EditPerfilComponent } from './pages/adminUser/editPerfil/editPerfil.component';
import { MyShoppingComponent } from './pages/adminUser/myShopping/myShopping.component';
import { MyShoppingListComponent } from './pages/adminUser/myShoppingList/myShoppingList.component';
import { CategoryComponent } from './pages/category/category.component';
import { CartComponent } from './pages/cart/cart.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { NotFoundComponent } from './pages/menssage/notFound/notFound.component';
import { LeftMenu } from './components/leftMenu';
import { Menu } from './components/menu';
import { Login } from './components/login';
import { ProductMini } from './components/productMini';
import { FloatButtonCart } from './components/floatButtonCart'
import { ApiService } from './services/api.service';
import { Configuration } from './services/config.service';
import { FloatButtonCartService } from './components/floatButtonCart/floatButtonCart.service';
import { routing } from './app.routing';
import { ToastyModule } from 'ng2-toasty';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    routing,
    ToastyModule.forRoot(),
    ReCaptchaModule
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    PaisComponent,
    ProductComponent,
    LogUserComponent,
    EditPerfilComponent,
    MyShoppingComponent,
    MyShoppingListComponent,
    CategoryComponent,
    CartComponent,
    PaymentComponent,
    NotFoundComponent,
    LeftMenu,
    Menu,
    Login,
    ProductMini,
    FloatButtonCart
  ],
  providers: [
    ApiService,
    Configuration,
    FloatButtonCartService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts